export default "__VITE_ASSET__93066a2e__"